import { FC } from 'react';

import { CompanyProfile } from 'models';

import { CaseStudies as CaseStudiesComponent } from 'components/company-profile/components/CaseStudies';
import { useCaseStudies } from 'components/company-profile/hooks/use-case-studies';
import { Section } from 'components/section/Section';

const CaseStudies: FC<{
    company: CompanyProfile;
}> = ({ company }) => {
    const { caseStudies } = useCaseStudies(company);

    const visibleArticles = caseStudies.filter((article) => article.teaser.image);

    return (
        <Section title="Case Studies" id="case-studies">
            <CaseStudiesComponent caseStudies={visibleArticles} companySlug={company.slug} />
        </Section>
    );
};

export { CaseStudies };
